// Central store constants used across the site
export const STORE = {
    name: "The Hardware Store",
    tagline: "India's electrical & plumbing supply partner for contractors, electricians and plumbers.",
    since: 2020,
    phoneDisplay: "+91 98185 58934",
    phoneDial: "+919818558934",
    whatsappNumber: "919818558934", // wa.me format
    email: "info@thehardwarestore.io",
    serviceArea: "India",
    hours: [
        { label: "Mon – Sat", value: "9:00 AM – 9:00 PM" },
        { label: "Sunday", value: "10:00 AM – 6:00 PM" },
    ],
};

export function waLink(message = "Hi The Hardware Store, I need electrical or plumbing supplies.") {
    const url = new URL(`https://wa.me/${STORE.whatsappNumber}`);
    url.searchParams.set("text", message);
    return url.toString();
}

export function telLink() {
    return `tel:${STORE.phoneDial}`;
}
